var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mgl-map-wrapper",staticStyle:{"height":"100%","width":"100%","position":"relative"}},[_c('div',{ref:"mapContainer",staticClass:"mgl-map-container",staticStyle:{"height":"100%","width":"100%"}}),(_vm.loaded)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }